import { Component, inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Contact, ContactInfosComplementary } from 'src/app/shared/models/iContact/contact/contact';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'underscore';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { TreeSelect } from 'primeng/treeselect';
import { TranslateService } from '@devinforius/i-essentials';
import { ServicesService } from 'src/app/shared/services/services.service';
import { forkJoin, Observable, of } from 'rxjs';
import { ConfigService } from 'src/app/shared/services/config.service';
import { NaturesService } from 'src/app/shared/services/natures.service';
import { SourcesService } from 'src/app/shared/services/sources.service';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import {
  BinderClassificationDtoV2,
  ContactTypeDto,
  DropdownClassificationCode,
  DropdownService,
  LowInformationContactDto,
  NatureDto,
  SourceDto,
} from 'src/app/shared/interfaces';
import { DocumentStatusDto } from 'src/app/shared/interfaces/documents/document-status-dto.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { BasicBinderForAdvancedSearch } from 'src/app/shared/models/classement/classeur';
import { BasicFolderForAdvancedSearch } from 'src/app/shared/models/classement/chemise';
import { Button } from 'src/app/shared/models/button';
import { ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { Cols } from 'src/app/shared/models/cols';
import { catchError, tap } from 'rxjs/operators';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ConfirmationService } from 'primeng/api';
import { ListOfAdvancedSearchsDisplayTable } from 'src/app/shared/models/iCourrier/me/personal-params';
import { Nature } from 'src/app/shared/models/iCourrier/nature';
import { MultipleStatutesService } from 'src/app/shared/services/multiple-statutes.service';
import { MultipleStatutesDTO } from 'src/app/shared/models/iCourrier/status-management/multiple-statutes';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { Mail } from 'src/app/shared/models/mails/mail';
import { Router } from '@angular/router';
import { MeService } from 'src/app/shared/services/me.service';
import { AdvancedSearch, NatureCustomFieldsSearch } from 'src/app/shared/interfaces/advanced-search/advanced-search.interface';
import { manageServicesSetAsTreeSelect, manageServicesToBeMerged } from 'src/app/shared/utils/manage-services-for-tree-select.utils';

@Component({
  selector: 'app-adv-search',
  templateUrl: './adv-search.component.html',
  styleUrls: ['./adv-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdvSearchComponent implements OnInit {
  @ViewChild('treeSelect') treeSelect: TreeSelect;
  @ViewChild('treeSelectDestServices') treeSelectDestServices: TreeSelect;

  public buttons: Button[] = [];
  public mails: Mail[] = [];
  public mailActive: Mail;
  public idMailActive: number;
  public welcomeMode: boolean;
  public hasAdvancedSearch = false;
  public resetTag = false;
  public pageTotal = 0;
  public defaultSearchDays = 365;
  public defaultSearchDateRange = '';

  public slugUrl: string;
  public contacts: Contact[] = [];

  public sendersContacts: Contact[] = [];
  public recipientsContacts: Contact[] = [];

  public displayComplementaryInfosForAContact = false;
  public contactInfosComplementary: ContactInfosComplementary[] = [];
  public selectedOptionDestService = null;
  public columnsContactInfoComplementary: Cols[] = [
    {
      field: 'type',
      header: 'advancedSearch.contactType',
      format: (value: string): string => {
        return value ? value : '/';
      },
    },
    {
      field: 'contactParent',
      header: 'advancedSearch.parentContact',
      format: (value: string): string => {
        return value ? value : 'Pas de contact parent';
      },
    },
    {
      field: 'impression_Adresse',
      header: 'advancedSearch.address',
      format: (value: string): string => {
        return value ? value : "Pas d'adresse";
      },
    },
    {
      field: 'impression_CodePostal',
      header: 'advancedSearch.zipCode',
      format: (value: string): string => {
        return value ? value : 'Pas de CP';
      },
    },
    {
      field: 'impression_Localite',
      header: 'advancedSearch.city',
      format: (value: string): string => {
        return value ? value : 'Pas de ville';
      },
    },
    {
      field: 'impression_Pays',
      header: 'advancedSearch.country',
      format: (value: string): string => {
        return value ? value : 'Belgique';
      },
    },
    {
      field: 'gsm',
      header: 'advancedSearch.mobilePhone',
      format: (value: string): string => {
        return value ? value : 'Pas de mobile';
      },
    },
    {
      field: 'telephone',
      header: 'advancedSearch.phone',
      format: (value: string): string => {
        return value ? value : 'Pas de téléphone';
      },
    },
    {
      field: 'mail',
      header: 'advancedSearch.email',
      format: (value: string): string => {
        return value ? value : "Pas d'email";
      },
    },
  ];

  public formSearch = new UntypedFormGroup({
    Confidentiel: new FormControl(null),
    BoolObjetText: new FormControl(null),
    category: new FormControl(null),
    Tag: new FormControl(null),
    Objet: new FormControl(null),
    SvcPropIds: new FormControl(null),
    Type: new FormControl(null),
    BoiteArchive: new FormControl(null),
    Id: new FormControl(null),

    ExpediteurIds: new FormControl(null),
    ExpediteurIdiAdmins: new FormControl(null),
    ExpediteurLibre: new FormControl(null),
    RefExpediteur: new FormControl(null),

    CourrierSansServices: new FormControl(null),
    CourrierSansDestinataires: new FormControl(null),

    DestinataireIds: new FormControl(null),
    DestinataireIdiAdmins: new FormControl(null),
    DestinataireLibre: new FormControl(null),
    DestinataireServiceIds: new FormControl(null),

    ReferenceRecommande: new FormControl(null),
    ClassementIds: new FormControl(null),
    ClasseurId: new FormControl(null),
    ChemiseId: new FormControl(null),
    NatureIds: new FormControl(null),
    MultipleStIds: new FormControl(null),
    SourceIds: new FormControl(null),
    StIds: new FormControl(null),
    NatureCustomFieldsSearch: new FormControl(null),
    recurrence: new FormControl(null),
    DtEntreeMin: new FormControl(null),
    DtEntreeMax: new FormControl(null),
    DtEcheanceMin: new FormControl(null),
    DtEcheanceMax: new FormControl(null),
    DtDocumentMin: new FormControl(null),
    DtDocumentMax: new FormControl(null),
    DtPostaleMin: new FormControl(null),
    DtPostaleMax: new FormControl(null),
    DtEncodageMin: new FormControl(null),
    DtEncodageMax: new FormControl(null),
    DtCreationMin: new FormControl(null),
    DtCreationMax: new FormControl(null),
    Remarques: new FormControl(null),
    Text: new FormControl(null),
    Key: new FormControl(null),
    ExportNatureCustomDatas: new FormControl(null),
    checkBindersIsArchived: new FormControl(null),
    checkFoldersIsArchived: new FormControl(null),

    sendersSource: new FormControl('iAdmin'),
    recipientsSource: new FormControl('iAdmin'),
  });
  public recipientSourceBoolean = false;
  public senderSourceBoolean = false;

  public services: DropdownService[] = [];
  public servicesList: ServicesPTreeSelect[] = [];
  public serviceParent: ServicesPTreeSelect[] = []; //array with the arbo
  public servicesParentChild: {
    label: string;
    value: number | string;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public classificationCodesLV: DropdownClassificationCode[] = [];
  public contactsTypes: ContactTypeDto[] = [];
  public binders: BasicBinderForAdvancedSearch[] = [];
  public folders: BasicFolderForAdvancedSearch[] = [];
  public natureListLV: { label: string; value: number; labelToSort: string }[] = [];
  public natureList: Nature[] = [];
  public tags: { label: string; value: number }[] = [];
  public sourceListLV: { label: string; value: number }[] = [];
  public statutGlobalLV: { label: string; value: number; color: string }[] = [];

  public configuration: ConfigDto;

  public searchLoaded = true;

  public typeEntrantSortantLV: { label: string; value: string }[] = [
    { label: 'homeCourrierChild.type.out', value: 'S' },
    { label: 'homeCourrierChild.type.in', value: 'E' },
    { label: 'homeCourrierChild.type.intern', value: 'I' },
  ];
  public typeEntrantSortant = '';

  public generalDatasFilterActive: string[] = [];
  public expediteursDatasFilterActive: string[] = [];
  public destinatairesDatasFilterActive: string[] = [];
  public donneesComplementairesDatasFilterActive: string[] = [];
  public donneesSupplementairesDatasFilterActive: string[] = [];
  public datesDatasFilterActive: string[] = [];
  public translationPlaceholderPTree = '';

  public loaded = false;

  public openSavedSearchs = false;
  public itemsSaved = [];
  public savedSearchColumn: Cols[] = [];
  public formSearchSaved = new UntypedFormGroup({
    name: new FormControl(),
    description: new FormControl(null, Validators.required),
    shared: new FormControl(true),
    hideInDashboard: new FormControl(false),
    displayOrder: new FormControl(null),
    value: new FormControl(null),
  });
  public updateMode = false;
  public updateID = null;
  public titleUpdateMode = '';
  public buttonsUpdateMode: Button[] = [];
  public savedModal = false;
  public boxesOptions: { value: string; label: string; icon: string; iconColor: string }[] = [
    { value: 'All', label: 'homeCourrier.menuBox.all', icon: 'dashboard-icon-all', iconColor: 'rgb(36, 52, 75)' },
    {
      value: 'Entrant',
      label: 'homeCourrier.menuBox.entrants',
      icon: 'dashboard-icon-entrant',
      iconColor: 'rgb(189, 39, 224)',
    },
    {
      value: 'Sortant',
      label: 'homeCourrier.menuBox.sortants',
      icon: 'dashboard-icon-sortant',
      iconColor: 'rgb(80, 226, 193)',
    },
    {
      value: 'Interne',
      label: 'homeCourrier.menuBox.internes',
      icon: 'dashboard-icon-intern',
      iconColor: 'rgb(80,227,194)',
    },
    {
      value: 'NonLus',
      label: 'homeCourrier.menuBox.nonLus',
      icon: 'dashboard-icon-non-lus',
      iconColor: 'rgb(255, 98, 96)',
    },
    { value: 'Lus', label: 'homeCourrier.menuBox.lus', icon: 'dashboard-icon-lu', iconColor: 'rgb(59, 222, 134)' },
    {
      value: 'PourInfo',
      label: 'homeCourrier.menuBox.pourInfo',
      icon: 'dashboard-icon-pour-info',
      iconColor: 'rgb(50, 197, 255)',
    },
    {
      value: 'APrendreEnCharge',
      label: 'homeCourrier.menuBox.aPrendreEnCharge',
      icon: 'dashboard-icon-prendre-en-charge',
      iconColor: 'rgb(36, 52, 75)',
    },
    {
      value: 'PrisEnCharge',
      label: 'homeCourrier.menuBox.prisEnCharge',
      icon: 'dashboard-icon-demandes-de-prises-en-charge',
      iconColor: 'rgb(247, 181, 0)',
    },
    {
      value: 'NonPrisEnCharge',
      label: 'homeCourrier.menuBox.nonPrisEnCharge',
      icon: 'dashboard-icon-demandes-non-prises-en-charge',
      iconColor: 'rgb(255, 98, 96)',
    },
    {
      value: 'AValider',
      label: 'homeCourrier.menuBox.aValider',
      icon: 'dashboard-icon-a-valider',
      iconColor: 'rgb(189, 39, 224)',
    },
    {
      value: 'ADistribuer',
      label: 'homeCourrier.menuBox.aDistribuer',
      icon: 'dashboard-icon-a-distribuer',
      iconColor: 'rgb(255, 184, 71)',
    },
    {
      value: 'ACompleter',
      label: 'homeCourrier.menuBox.aCompleter',
      icon: 'dashboard-icon-a-completer',
      iconColor: 'rgb(36, 52, 75)',
    },
    {
      value: 'MalRoutes',
      label: 'homeCourrier.menuBox.malRoutes',
      icon: 'dashboard-icon-mal-routes',
      iconColor: 'rgb(189, 39, 224)',
    },
    {
      value: 'Epingles',
      label: 'homeCourrier.menuBox.epingles',
      icon: 'dashboard-icon-epingles',
      iconColor: 'rgb(247, 181, 0)',
    },
    {
      value: 'PourAction',
      label: 'homeCourrier.menuBox.pourAction',
      icon: 'dashboard-icon-pour-action',
      iconColor: 'rgb(96, 205, 255)',
    },
    {
      value: 'RecemmentConsultes',
      label: 'homeCourrier.menuBox.recemmentConsultes',
      icon: 'dashboard-icon-recemment-consultes',
      iconColor: 'rgb(80, 226, 193)',
    },
    {
      value: 'RecemmentCrees',
      label: 'homeCourrier.menuBox.recemmentCrees',
      icon: 'dashboard-icon-recemment-crees',
      iconColor: 'rgb(96, 205, 255)',
    },
    {
      value: 'AClasser',
      label: 'homeCourrier.menuBox.aClasser',
      icon: 'dashboard-icon-a-classer',
      iconColor: 'rgb(255, 184, 71)',
    },
  ];

  public dataToPrepareForForm: {
    controls?: {
      customFieldId: number;
      id: number;
      name: string;
      description: string;
      label: string;
      textValue: string;
      dateValue: string;
      integerValue: number;
      decimalValue: number;
      numberValue: number;
      listValueItemId: number[];
      type: string;
      natureId: number;
      validators: object;
    }[];
  } = {};

  public complementDatasToSend: NatureCustomFieldsSearch[] = [];
  public natureWithComplementaryDatas: Nature;
  public countOfComplementaryDatasNature = 0;
  public hasNatureComplementaryDatas: boolean; // boolean that indicates if the nature chosen has complementary datas

  public accordionGeneralSelected = false;
  public accordionExpediteursSelected = false;
  public accordionRecipientSelected = false;
  public accordionSupplementarySelected = false;
  public accordionComplementarySelected = false;
  public accordionDatesSelected = false;

  public displayCourrierType = true;
  public headerForModal: string;
  public serviceDataForClassificationSearchModal: { serviceProprietaireId: number };
  public displayModalClassificationSearch = false;

  public get formControlNameForSender(): AbstractControl {
    if (this.formSearch.value.sendersSource === 'iAdmin') {
      return this.formSearch.get('ExpediteurIdiAdmins');
    }
    return this.formSearch.get('ExpediteurIds');
  }

  public get formControlNameForRecipient(): AbstractControl {
    if (this.formSearch.value.recipientsSource === 'iAdmin') {
      return this.formSearch.get('DestinataireIdiAdmins');
    }
    return this.formSearch.get('DestinataireIds');
  }

  private readonly spinner = inject(NgxSpinnerService);

  constructor(
    // private spinner: NgxSpinnerService,
    private titleService: Title,
    public toastr: ToastrService,
    public translater: TranslateService,
    private servicesService: ServicesService,
    private contactsService: ContactsService,
    private configurationService: ConfigService,
    private naturesService: NaturesService,
    private multipleStatutesService: MultipleStatutesService,
    private sourcesService: SourcesService,
    private documentsService: DocumentsService,
    private classificationsService: ClassificationsService,
    private router: Router,
    public confirmService: ConfirmationService,
    private contactsGlobalService: ContactsGlobalService,
    private meService: MeService
  ) {}

  ngOnInit(): void {
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');
    this.translateColumns();
    this.titleService.setTitle(this.translater.translate('tabsTitle.search'));
    this.loaded = false;
    forkJoin({
      configuration: this.configurationService.fetchConfig().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération de la configuration');
          return of([]);
        })
      ),
      services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des services');
          return of([]);
        })
      ),
      sendersContacts: this.contactsService.fetchContactsSummary('iAdmin').pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des contacts des expéditeurs');
          return of([]);
        })
      ),
      recipientsContacts: this.contactsService.fetchContactsSummary('iAdmin').pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des contacts des destinataires');
          return of([]);
        })
      ),
      natures: this.naturesService.fetchNatures().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des natures');
          return of([]);
        })
      ),
      tags: this.multipleStatutesService.getMultipleStatus().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des tags');
          return of([]);
        })
      ),
      sources: this.sourcesService.fetchSources().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des sources');
          return of([]);
        })
      ),
      statutes: this.documentsService.fetchDocumentsStatutes().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des status');
          return of([]);
        })
      ),
      classificationsCodes: this.classificationsService.fetchMappedClassificationCodesToPrimeNGDropdowns(true).pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des codes de classements');
          return of([]);
        })
      ),
      contactsTypes: this.contactsGlobalService.fetchContactTypes().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des types de contacts');
          return of([]);
        })
      ),
    }).subscribe({
      next: (res: {
        configuration: ConfigDto;
        services: DropdownService[];
        sendersContacts: LowInformationContactDto[];
        recipientsContacts: LowInformationContactDto[];
        natures: NatureDto[];
        tags: MultipleStatutesDTO[];
        sources: SourceDto[];
        statutes: DocumentStatusDto[];
        classificationsCodes: DropdownClassificationCode[];
        contactsTypes: ContactTypeDto[];
      }) => {
        const {
          configuration,
          services,
          sendersContacts,
          recipientsContacts,
          natures,
          tags,
          sources,
          statutes,
          classificationsCodes,
          contactsTypes,
        } = res;

        this.handleConfiguration(configuration);
        this.handleServices(services);
        this.handleSendersContacts(sendersContacts);
        this.handleRecipientsContacts(recipientsContacts);
        this.handleNatures(natures);
        this.handleTags(tags);
        this.handleSources(sources);
        this.handleStatutes(statutes);
        this.handleClassificationCodes(classificationsCodes);
        this.handleContactsTypes(contactsTypes);
        this.initButtons();

        this.loaded = true;
      },
    });
  }

  private translateColumns(): void {
    this.columnsContactInfoComplementary.map((col) => (col.header = this.translater.translate(col.header)));
    this.savedSearchColumn = [
      {
        field: 'description',
        header: this.translater.translate('description'),
        format: (value: string): string => {
          if (value) {
            return value;
          } else {
            return '/';
          }
        },
      },
      {
        field: 'buttonUse',
        header: this.translater.translate('use'),
        format: (): string => {
          const useLabel = this.translater.translate('use');
          return `<div class="btn advanced-search__button--blue d-block w-100">${useLabel}</div>`;
        },
        click: (value: ListOfAdvancedSearchsDisplayTable): void => {
          this.patchFormSavedSearch(value);
        },
      },
      {
        field: 'buttonEdit',
        header: this.translater.translate('edit'),
        format: (): string => {
          const editLabel = this.translater.translate('edit');
          return `<div class="btn advanced-search__button--blue d-block w-100">${editLabel}</div>`;
        },
        click: (value: ListOfAdvancedSearchsDisplayTable): void => {
          this.patchFormSearchForModification(value);
        },
      },
      {
        field: 'buttonDelete',
        header: this.translater.translate('delete'),
        format: (): string => {
          const deleteLabel = this.translater.translate('delete');
          return `<div class="btn advanced-search__button--red d-block w-100">${deleteLabel}</div>`;
        },
        click: (value: ListOfAdvancedSearchsDisplayTable): void => {
          this.deleteSearch(value);
        },
      },
    ];
    this.buttonsUpdateMode = [
      {
        text: this.translater.translate('advancedSearch.cancelEdit'),
        styleClass: 'red',
        disabled: false,
        click: () => {
          this.confirmService.confirm({
            message: this.translater.translate('confirmation.cancelModificationOfAdvancedSearch'),
            key: 'confirmReinitSavedSearch',
            accept: () => {
              this.resetAllDatas();
            },
          });
        },
      },
      {
        text: this.translater.translate('advancedSearch.save'),
        styleClass: 'green',
        disabled: false,
        click: () => {
          this.updateSearch();
        },
      },
    ];
  }

  public initButtons(): void {
    this.buttons.push(
      {
        text: 'Réinitialiser',
        styleClass: 'red',
        disabled: false,
        click: () => {
          this.resetAllDatas();
        },
      },
      {
        text: 'Charger une recherche sauvegardée',
        styleClass: 'blue',
        icon: 'bi bi-clock-fill',
        iconPosition: 'left',
        disabled: false,
        click: () => {
          this.openSavedSearch();
        },
      },
      {
        text: 'Enregistrer cette recherche',
        styleClass: 'blue',
        icon: 'bi bi-star-fill',
        iconPosition: 'left',
        disabled: false,
        click: () => {
          this.savedModal = true;
        },
      },
      {
        text: 'Rechercher',
        styleClass: 'green',
        icon: 'bi bi-search',
        iconPosition: 'left',
        disabled: false,
        click: () => {
          this.resetTag = true;
          this.searchFull();
        },
      }
    );
  }

  public handleConfiguration(configuration: ConfigDto): void {
  this.configuration = configuration;
  this.defaultSearchDays = configuration?.mails?.nbrDaysForSearchCalculation ?? 365;
  this.computeDefaultSearchDateRange();
  }

  private computeDefaultSearchDateRange(): void {
    const dateFrom = moment().subtract(this.defaultSearchDays, 'days').format('DD/MM/YYYY');
    const dateTo = moment().format('DD/MM/YYYY');
    this.defaultSearchDateRange = `${dateFrom} - ${dateTo}`;
  }

  public handleServices(services: DropdownService[]): void {
    const datasForService = manageServicesSetAsTreeSelect(services, this.translater);
    this.serviceParent = datasForService.servicesForSingleCheck;
    this.servicesList = datasForService.servicesForMultiCheck;
    this.servicesParentChild = manageServicesToBeMerged(services);
  }

  public handleSendersContacts(sendersContacts: LowInformationContactDto[]): void {
    const mappedContacts = sendersContacts.map((contact) => new Contact(contact));
    this.sendersContacts = mappedContacts;
    this.sendersContacts.map((c) => {
      if (c) {
        c.name = (c.prenom ?? '') + ' ' + (c.nom ? c.nom : '');
        c.label = (c.prenom ? c.prenom : '') + ' ' + (c.nom ? c.nom : '');
        c.value = c.id;
        c.typeContactName = c.typeContact ? c.typeContact.typeContact : null;
      }
    });
  }

  public handleRecipientsContacts(recipientsContacts: LowInformationContactDto[]): void {
    const mappedContacts = recipientsContacts.map((contact) => new Contact(contact));
    this.recipientsContacts = mappedContacts;
    this.recipientsContacts.map((c) => {
      if (c) {
        c.name = (c.prenom ? c.prenom : '') + ' ' + (c.nom ? c.nom : '');
        c.label = (c.prenom ? c.prenom : '') + ' ' + (c.nom ? c.nom : '');
        c.value = c.id;
        c.typeContactName = c.typeContact ? c.typeContact.typeContact : null;
      }
    });
  }

  public handleNatures(natures: NatureDto[]): void {
    this.natureList = natures;
    natures.map((item) => {
      this.natureListLV.push({
        label: item.description,
        value: item.id,
        labelToSort: item.description.toLowerCase(),
      });
    });
  }

  public handleTags(tags: MultipleStatutesDTO[]): void {
    this.tags = [];

    if (tags.length > 0) {
      tags.map((item) => {
        if (!item.notUsed) {
          if (item.description) {
            this.tags.push({ label: item.description, value: item.id });
          }
        }
      });
    }
  }

  public handleSources(sources: SourceDto[]): void {
    this.sourceListLV = [];
    sources.map((item) => {
      this.sourceListLV.push({ label: item.description, value: item.id });
    });
  }

  public handleStatutes(statutes: DocumentStatusDto[]): void {
    if (statutes.length > 0) {
      statutes.map((item) => {
        this.statutGlobalLV.push({
          label: item.description,
          value: item.id,
          color: item.color && item.color !== 'Pas de couleur' ? item.color : '#ffffff',
        });
      });
    }
  }

  public handleClassificationCodes(classificationsCodes: DropdownClassificationCode[]): void {
    this.classificationCodesLV = classificationsCodes;
  }

  public handleContactsTypes(contactsTypes: ContactTypeDto[]): void {
    this.contactsTypes = contactsTypes;
  }

  //filterOnShow va permettre d'outre passer le fait d'attendre un length === 1 ou 2 ou 3 pour les input quand on charge une recherche avancée. En effet, si l'input est 'maison', il ne passerait pas au if, sauf avec filterOnShow
  //datas for Données générales Accordion Tab
  changeGeneralDataFilter(type, filterOnShow = false): void {
    if (type === 'Confidentiel') {
      //boolean
      if (this.formSearch.value.Confidentiel) {
        this.generalDatasFilterActive.push('Confidentiel');
      } else {
        const index = this.generalDatasFilterActive.indexOf('Confidentiel');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'BoolObjetText') {
      //boolean
      if (this.formSearch.value.BoolObjetText) {
        this.generalDatasFilterActive.push('BoolObjetText');
      } else {
        const index = this.generalDatasFilterActive.indexOf('BoolObjetText');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'Tag') {
      //dropdown
      const shouldDisplayMailType =
        this.formSearch.value.Tag === 'Entrant' ||
        this.formSearch.value.Tag === 'Sortant' ||
        this.formSearch.value.Tag === 'Interne' ||
        this.formSearch.value.Tag === 'AValider';

      if (shouldDisplayMailType) {
        this.displayCourrierType = false;
        this.formSearch.patchValue({ Type: null }); //on remet a null, au cas ou
        const index = this.generalDatasFilterActive.indexOf('Type');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null; //on enleve aussi le filtre affiché s'il en existe un
      } else {
        this.displayCourrierType = true;
      }

      if (this.formSearch.value.Tag !== null) {
        const index = this.generalDatasFilterActive.indexOf('Tag');
        if (index === -1) {
          this.generalDatasFilterActive.push('Tag');
        }
      } else {
        const index = this.generalDatasFilterActive.indexOf('Tag');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'SvcPropIds') {
      //p-tree checkbox
      if (this.formSearch.value.SvcPropIds && this.formSearch.value.SvcPropIds.length > 0) {
        const index = this.generalDatasFilterActive.indexOf('SvcPropIds');
        if (index === -1) {
          this.generalDatasFilterActive.push('SvcPropIds');
        }
        if (this.formSearch.value.ClassementIds?.length === 1 && this.formSearch.value.SvcPropIds?.length === 1) {
          //! on ne cherche la farde que si UN ET UN SEUL code a été coché ainsi que UN seul service
          this.getBinders(this.formSearch.value.ClassementIds[0]);
        } else {
          this.resetBindersAndFolders();
        }
      } else {
        const index = this.generalDatasFilterActive.indexOf('SvcPropIds');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
        this.resetBindersAndFolders();
      }
    }
    if (type === 'Objet') {
      //input
      if (this.formSearch.value.Objet !== null && this.formSearch.value.Objet.length > 0) {
        if (
          this.formSearch.value.Objet.length === 1 ||
          this.formSearch.value.Objet.length === 2 ||
          this.formSearch.value.Objet.length === 3 ||
          filterOnShow
        ) {
          //besoin de check 3x pcq s'ils écrivent vite, ca saute le 1 ou le 2...
          const index = this.generalDatasFilterActive.indexOf('Objet');
          if (index === -1) {
            this.generalDatasFilterActive.push('Objet');
          }
        }
      } else {
        const index = this.generalDatasFilterActive.indexOf('Objet');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'Type') {
      // dropdown
      if (this.formSearch.value.Type !== null) {
        const index = this.generalDatasFilterActive.indexOf('Type');
        if (index === -1) {
          this.generalDatasFilterActive.push('Type');
        }
      } else {
        const index = this.generalDatasFilterActive.indexOf('Type');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'BoiteArchive') {
      //input
      if (this.formSearch.value.BoiteArchive !== null && this.formSearch.value.BoiteArchive.length > 0) {
        if (
          this.formSearch.value.BoiteArchive.length === 1 ||
          this.formSearch.value.BoiteArchive.length === 2 ||
          this.formSearch.value.BoiteArchive.length === 3 ||
          filterOnShow
        ) {
          //besoin de check 3x pcq s'ils écrivent vite, ca saute le 1 ou le 2...
          const index = this.generalDatasFilterActive.indexOf('BoiteArchive');
          if (index === -1) {
            this.generalDatasFilterActive.push('BoiteArchive');
          }
        }
      } else {
        const index = this.generalDatasFilterActive.indexOf('BoiteArchive');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'Id') {
      //input
      if (this.formSearch.value.Id !== null && this.formSearch.value.Id.length > 0) {
        if (this.formSearch.value.Id.length === 1 || this.formSearch.value.Id.length === 2 || this.formSearch.value.Id.length === 3 || filterOnShow) {
          //besoin de check 3x pcq s'ils écrivent vite, ca saute le 1 ou le 2...
          const index = this.generalDatasFilterActive.indexOf('Id');
          if (index === -1) {
            this.generalDatasFilterActive.push('Id');
          }
        }
      } else {
        const index = this.generalDatasFilterActive.indexOf('Id');
        index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtEntreeMin') {
  if (this.formSearch.value.DtEntreeMin !== null) {
    const index = this.generalDatasFilterActive.indexOf('DtEntreeMin');
    if (index === -1) this.generalDatasFilterActive.push('DtEntreeMin');
  } else {
    const index = this.generalDatasFilterActive.indexOf('DtEntreeMin');
    index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
  }
}
if (type === 'DtEntreeMax') {
  if (this.formSearch.value.DtEntreeMax !== null) {
    const index = this.generalDatasFilterActive.indexOf('DtEntreeMax');
    if (index === -1) this.generalDatasFilterActive.push('DtEntreeMax');
  } else {
    const index = this.generalDatasFilterActive.indexOf('DtEntreeMax');
    index > -1 ? this.generalDatasFilterActive.splice(index, 1) : null;
  }
}
  }

  //filterOnShow va permettre d'outre passer le fait d'attendre un length === 1 ou 2 ou 3 pour les input quand on charge une recherche avancée. En effet, si l'input est 'maison', il ne passerait pas au if, sauf avec filterOnShow
  //Datas for Expediteur Accordion Tab
  changeExpediteursDataFilter(
    type: 'ExpediteurIds' | 'ExpediteurIdiAdmins' | 'ExpediteurLibre' | 'RefExpediteur',
    filterOnShow = false
  ): void {
    switch (type) {
      case 'ExpediteurIds':
        if (this.formSearch.value.ExpediteurIds !== null && this.formSearch.value.ExpediteurIds.length > 0) {
          const index = this.expediteursDatasFilterActive.indexOf('ExpediteurIds');
          if (index === -1) {
            this.expediteursDatasFilterActive.push('ExpediteurIds');
          }
        } else {
          const index = this.expediteursDatasFilterActive.indexOf('ExpediteurIds');
          index > -1 ? this.expediteursDatasFilterActive.splice(index, 1) : null;
        }
        break;
      case 'ExpediteurIdiAdmins':
        if (this.formSearch.value.ExpediteurIdiAdmins !== null && this.formSearch.value.ExpediteurIdiAdmins.length > 0) {
          const index = this.expediteursDatasFilterActive.indexOf('ExpediteurIdiAdmins');
          if (index === -1) {
            this.expediteursDatasFilterActive.push('ExpediteurIdiAdmins');
          }
        } else {
          const index = this.expediteursDatasFilterActive.indexOf('ExpediteurIdiAdmins');
          index > -1 ? this.expediteursDatasFilterActive.splice(index, 1) : null;
        }
        break;
      case 'ExpediteurLibre':
        if (this.formSearch.value.ExpediteurLibre !== null && this.formSearch.value.ExpediteurLibre.length > 0) {
          if (
            this.formSearch.value.ExpediteurLibre.length === 1 ||
            this.formSearch.value.ExpediteurLibre.length === 2 ||
            this.formSearch.value.ExpediteurLibre.length === 3 ||
            filterOnShow
          ) {
            //besoin de check 3x pcq s'ils écrivent vite, ca saute le 1 ou le 2...
            const index = this.expediteursDatasFilterActive.indexOf('ExpediteurLibre');
            if (index === -1) {
              this.expediteursDatasFilterActive.push('ExpediteurLibre');
            }
          }
        } else {
          const index = this.expediteursDatasFilterActive.indexOf('ExpediteurLibre');
          index > -1 ? this.expediteursDatasFilterActive.splice(index, 1) : null;
        }
        break;
      case 'RefExpediteur':
        if (this.formSearch.value.RefExpediteur !== null && this.formSearch.value.RefExpediteur.length > 0) {
          if (
            this.formSearch.value.RefExpediteur.length === 1 ||
            this.formSearch.value.RefExpediteur.length === 2 ||
            this.formSearch.value.RefExpediteur.length === 3 ||
            filterOnShow
          ) {
            const index = this.expediteursDatasFilterActive.indexOf('RefExpediteur');
            if (index === -1) {
              this.expediteursDatasFilterActive.push('RefExpediteur');
            }
          }
        } else {
          const index = this.expediteursDatasFilterActive.indexOf('RefExpediteur');
          index > -1 ? this.expediteursDatasFilterActive.splice(index, 1) : null;
        }
    }
  }

  //filterOnShow va permettre d'outre passer le fait d'attendre un length === 1 ou 2 ou 3 pour les input quand on charge une recherche avancée. En effet, si l'input est 'maison', il ne passerait pas au if, sauf avec filterOnShow
  //Datas for Destinataire Accordion Tab
  changeDestinataireDataFilter(type, filterOnShow = false): void {
    if (type === 'CourrierSansServices') {
      //boolean
      if (this.formSearch.value.CourrierSansServices === true) {
        this.destinatairesDatasFilterActive.push('CourrierSansServices');
      } else {
        const index = this.destinatairesDatasFilterActive.indexOf('CourrierSansServices');
        index > -1 ? this.destinatairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'CourrierSansDestinataires') {
      //boolean
      if (this.formSearch.value.CourrierSansDestinataires === true) {
        this.destinatairesDatasFilterActive.push('CourrierSansDestinataires');
      } else {
        const index = this.destinatairesDatasFilterActive.indexOf('CourrierSansDestinataires');
        index > -1 ? this.destinatairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DestinataireIds') {
      //multiSelect
      if (this.formSearch.value.DestinataireIds !== null && this.formSearch.value.DestinataireIds.length > 0) {
        const index = this.destinatairesDatasFilterActive.indexOf('DestinataireIds');
        if (index === -1) {
          this.destinatairesDatasFilterActive.push('DestinataireIds');
        }
      } else {
        const index = this.destinatairesDatasFilterActive.indexOf('DestinataireIds');
        index > -1 ? this.destinatairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DestinataireIdiAdmins') {
      //multiSelect
      if (this.formSearch.value.DestinataireIdiAdmins !== null && this.formSearch.value.DestinataireIdiAdmins.length > 0) {
        const index = this.destinatairesDatasFilterActive.indexOf('DestinataireIdiAdmins');
        if (index === -1) {
          this.destinatairesDatasFilterActive.push('DestinataireIdiAdmins');
        }
      } else {
        const index = this.destinatairesDatasFilterActive.indexOf('DestinataireIdiAdmins');
        index > -1 ? this.destinatairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DestinataireLibre') {
      //input
      if (this.formSearch.value.DestinataireLibre !== null && this.formSearch.value.DestinataireLibre.length > 0) {
        if (
          this.formSearch.value.DestinataireLibre.length === 1 ||
          this.formSearch.value.DestinataireLibre.length === 2 ||
          this.formSearch.value.DestinataireLibre.length === 3 ||
          filterOnShow
        ) {
          //besoin de check 3x pcq s'ils écrivent vite, ca saute le 1 ou le 2...
          const index = this.destinatairesDatasFilterActive.indexOf('DestinataireLibre');
          if (index === -1) {
            this.destinatairesDatasFilterActive.push('DestinataireLibre');
          }
        }
      } else {
        const index = this.destinatairesDatasFilterActive.indexOf('DestinataireLibre');
        index > -1 ? this.destinatairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DestinataireServiceIds') {
      //p-tree
      if (this.formSearch.value.DestinataireServiceIds !== null) {
        const index = this.destinatairesDatasFilterActive.indexOf('DestinataireServiceIds');
        if (index === -1) {
          this.destinatairesDatasFilterActive.push('DestinataireServiceIds');
        }
      } else {
        const index = this.destinatairesDatasFilterActive.indexOf('DestinataireServiceIds');
        index > -1 ? this.destinatairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'ReferenceRecommande') {
      //input
      if (this.formSearch.value.ReferenceRecommande !== null && this.formSearch.value.ReferenceRecommande.length > 0) {
        if (
          this.formSearch.value.ReferenceRecommande.length === 1 ||
          this.formSearch.value.ReferenceRecommande.length === 2 ||
          this.formSearch.value.ReferenceRecommande.length === 3 ||
          filterOnShow
        ) {
          //besoin de check 3x pcq s'ils écrivent vite, ca saute le 1 ou le 2...
          const index = this.destinatairesDatasFilterActive.indexOf('ReferenceRecommande');
          if (index === -1) {
            this.destinatairesDatasFilterActive.push('ReferenceRecommande');
          }
        }
      } else {
        const index = this.destinatairesDatasFilterActive.indexOf('ReferenceRecommande');
        index > -1 ? this.destinatairesDatasFilterActive.splice(index, 1) : null;
      }
    }
  }

  changeDonneesSupplementairesDataFilter(type, formWithDatas: AdvancedSearch = null): void {
    if (type === 'ClassementIds') {
      //multiSelect
      if (this.formSearch.value.ClassementIds !== null && this.formSearch.value.ClassementIds.length > 0) {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('ClassementIds');
        if (index === -1) {
          this.donneesSupplementairesDatasFilterActive.push('ClassementIds');
        }

        if (this.formSearch.value.ClassementIds?.length === 1 && this.formSearch.value.SvcPropIds?.length === 1) {
          //! on ne cherche la farde que si UN ET UN SEUL code a été coché ainsi que UN seul service
          this.getBinders(this.formSearch.value.ClassementIds[0]);
        } else {
          // Si plus d'un alors on vide tout
          this.resetBindersAndFolders();
        }
      } else {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('ClassementIds');
        index > -1 ? this.donneesSupplementairesDatasFilterActive.splice(index, 1) : null;
        this.resetBindersAndFolders();
      }
    }
    if (type === 'ClasseurId') {
      //dropdown
      if (this.formSearch.value.ClasseurId !== null) {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('ClasseurId');
        if (index === -1) {
          this.donneesSupplementairesDatasFilterActive.push('ClasseurId');
        }
        this.getFolders(this.formSearch.value.ClasseurId);
      } else {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('ClasseurId');
        index > -1 ? this.donneesSupplementairesDatasFilterActive.splice(index, 1) : null;
        this.resetFolders();
      }
    }
    if (type === 'ChemiseId') {
      //dropdown
      if (this.formSearch.value.ClasseurId !== null) {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('ChemiseId');
        if (index === -1) {
          this.donneesSupplementairesDatasFilterActive.push('ChemiseId');
        }
      } else {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('ChemiseId');
        index > -1 ? this.donneesSupplementairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'NatureIds') {
      //multiSelect
      if (this.formSearch.value.NatureIds !== null && this.formSearch.value.NatureIds.length > 0) {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('NatureIds');
        if (index === -1) {
          this.donneesSupplementairesDatasFilterActive.push('NatureIds');
        }
        if (this.formSearch.value.NatureIds.length === 1) {
          //Si on a une et une seule nature => on va récupérer les données complémentaires liées a la nature
          this.checkForComplementaryDatas(this.formSearch.value.NatureIds, formWithDatas);
        } else {
          this.formSearch.patchValue({
            NatureCustomFieldsSearch: null,
          });
          this.natureWithComplementaryDatas = null;
          this.complementDatasToSend = [];
        }
      } else {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('NatureIds');
        index > -1 ? this.donneesSupplementairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'MultipleStIds') {
      //multiSelect
      if (this.formSearch.value.MultipleStIds !== null && this.formSearch.value.MultipleStIds.length > 0) {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('MultipleStIds');
        if (index === -1) {
          this.donneesSupplementairesDatasFilterActive.push('MultipleStIds');
        }
      } else {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('MultipleStIds');
        index > -1 ? this.donneesSupplementairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'SourceIds') {
      //multiSelect
      if (this.formSearch.value.SourceIds !== null && this.formSearch.value.SourceIds.length > 0) {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('SourceIds');
        if (index === -1) {
          this.donneesSupplementairesDatasFilterActive.push('SourceIds');
        }
      } else {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('SourceIds');
        index > -1 ? this.donneesSupplementairesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'StIds') {
      // dropdown
      if (this.formSearch.value.StIds !== null) {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('StIds');
        if (index === -1) {
          this.donneesSupplementairesDatasFilterActive.push('StIds');
        }
      } else {
        const index = this.donneesSupplementairesDatasFilterActive.indexOf('StIds');
        index > -1 ? this.donneesSupplementairesDatasFilterActive.splice(index, 1) : null;
      }
    }
  }

  getBinders(classificationCodeID: number): Promise<boolean> {
    return new Promise((resolve) => {
      this.binders = [];
      if (classificationCodeID) {
        this.classificationsService.fetchFoldersClassificationV2({ SvcIds: this.formSearch.value.SvcPropIds, IncludePartages: true }).subscribe({
          next: (res) => {
            // Ici on a tous les classements d'un service
            res.map((classification) => {
              //on va récupérer uniquement ceux qui ont le bon classementID
              if (classification.id === classificationCodeID) {
                if (this.formSearch.value.checkBindersIsArchived) {
                  //Si on a coché "archivés" on les prend tous
                  this.binders = [].concat.apply(this.binders, classification.classeurs);
                  this.binders = _.uniq(this.binders, 'id');
                } else {
                  //Si on a pas coché, on filtre sur les non archivés
                  this.binders = [].concat(
                    this.binders,
                    classification.classeurs.filter((item) => item.archived === false)
                  );
                }
              }
            });
            resolve(true);
          },
        });
      }
    });
  }

  fetchBinders(classificationCodeId: number): Observable<BinderClassificationDtoV2[]> {
    if (!classificationCodeId) return of([]);

    return this.classificationsService.fetchFoldersClassificationV2({ SvcIds: this.formSearch.value.SvcPropIds, IncludePartages: true }).pipe(
      tap((binders) => {
        binders.forEach((binder) => {
          if (binder.id !== classificationCodeId) return;

          if (!this.formSearch.value.checkBindersIsArchived) {
            this.binders = [].concat.apply(
              this.binders,
              binder.classeurs.filter((item) => !item.archived)
            );
            return;
          }

          this.binders = binder.classeurs;
          this.binders = _.uniq(this.binders, 'id');
        });
      })
    );
  }

  getFolders(binderId): void {
    this.folders = [];
    if (binderId) {
      const currentBinderChosen = this.binders.find((binder) => binder.id === binderId);
      if (this.formSearch.value.checkFoldersIsArchived) {
        this.folders = [].concat.apply(this.folders, currentBinderChosen.chemises);
        this.folders = _.uniq(this.folders, 'id');
      } else {
        this.folders = [].concat.apply(
          this.folders,
          currentBinderChosen.chemises.filter((item) => item.archived === false)
        );
      }
    }
  }

  displayArchived(typeOfClassement: 'binder' | 'folder'): void {
    if (typeOfClassement === 'binder') {
      this.getBinders(this.formSearch.value.ClassementIds[0]);
    } else if (typeOfClassement === 'folder') {
      this.getFolders(this.formSearch.value.ClasseurId);
    }
  }

  getTooltipForClassificationSearch(): string {
    if (this.formSearch.value.SvcPropIds?.length !== 1) {
      return this.translater.translate('error.pleaseAddOnlyAService');
    } else {
      return '';
    }
  }

  openModalClassement(): void {
    if (this.formSearch.value.SvcPropIds) {
      this.headerForModal = this.translater.translate('advancedSearch.mailClassification');
      this.serviceDataForClassificationSearchModal = {
        serviceProprietaireId: this.formSearch.value.SvcPropIds,
      };
      this.displayModalClassificationSearch = true;
    } else {
      this.toastr.warning(this.translater.translate('error.pleaseAddOnlyAService'));
    }
  }

  onCloseClassificationSearchModal(value): void {
    this.displayModalClassificationSearch = false;
    if (value && (value.classementId !== null || value.classeurId !== null || value.chemiseId !== null)) {
      this.formSearch.patchValue({
        ClassementIds: [value.classementId],
        ClasseurId: value.classeurId ? value.classeurId : null,
        ChemiseId: value.chemiseId ? value.chemiseId : null,
      });
      this.changeDonneesSupplementairesDataFilter('ClassementIds');
      if (value.classeurId) {
        this.getBinders(value.classementId).then(() => {
          this.changeDonneesSupplementairesDataFilter('ClasseurId');
          if (value.chemiseId) {
            this.changeDonneesSupplementairesDataFilter('ChemiseId');
            this.getFolders(value.classeurId);
          }
        });
      }
    }
  }

  //filterOnShow va permettre d'outre passer le fait d'attendre un length === 1 ou 2 ou 3 pour les input quand on charge une recherche avancée. En effet, si l'input est 'maison', il ne passerait pas au if, sauf avec filterOnShow
  changeDataDataFilter(type, filterOnShow = false): void {
    if (type === 'recurrence') {
      //boolean
      if (this.formSearch.value.recurrence === true) {
        this.datesDatasFilterActive.push('recurrence');
      } else {
        const index = this.datesDatasFilterActive.indexOf('recurrence');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtEncodageMin') {
      //date
      if (this.formSearch.value.DtEncodageMin !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtEncodageMin');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtEncodageMin');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtEncodageMin');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtEncodageMax') {
      //date
      if (this.formSearch.value.DtEncodageMax !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtEncodageMax');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtEncodageMax');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtEncodageMax');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtEntreeMin') {
      //date
      if (this.formSearch.value.DtEntreeMin !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtEntreeMin');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtEntreeMin');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtEntreeMin');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtEntreeMax') {
      //date
      if (this.formSearch.value.DtEntreeMax !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtEntreeMax');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtEntreeMax');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtEntreeMax');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtEcheanceMin') {
      //date
      if (this.formSearch.value.DtEcheanceMin !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtEcheanceMin');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtEcheanceMin');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtEcheanceMin');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtEcheanceMax') {
      //date
      if (this.formSearch.value.DtEcheanceMax !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtEcheanceMax');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtEcheanceMax');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtEcheanceMax');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtDocumentMin') {
      //date
      if (this.formSearch.value.DtDocumentMin !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtDocumentMin');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtDocumentMin');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtDocumentMin');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtDocumentMax') {
      //date
      if (this.formSearch.value.DtDocumentMax !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtDocumentMax');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtDocumentMax');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtDocumentMax');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtPostaleMin') {
      //date
      if (this.formSearch.value.DtPostaleMin !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtPostaleMin');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtPostaleMin');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtPostaleMin');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtPostaleMax') {
      //date
      if (this.formSearch.value.DtPostaleMax !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtPostaleMax');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtPostaleMax');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtPostaleMax');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtCreationMin') {
      //date
      if (this.formSearch.value.DtCreationMin !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtCreationMin');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtCreationMin');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtCreationMin');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'DtCreationMax') {
      //date
      if (this.formSearch.value.DtCreationMax !== null) {
        const index = this.datesDatasFilterActive.indexOf('DtCreationMax');
        if (index === -1) {
          this.datesDatasFilterActive.push('DtCreationMax');
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('DtCreationMax');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
    if (type === 'Remarques') {
      if (this.formSearch.value.Remarques !== null && this.formSearch.value.Remarques.length > 0) {
        if (this.formSearch.value.Remarques.length <= 3 || filterOnShow) {
          //besoin de check 3x pcq s'ils écrivent vite, ca saute le 1 ou le 2...
          const index = this.datesDatasFilterActive.indexOf('Remarques');
          if (index === -1) {
            this.datesDatasFilterActive.push('Remarques');
          }
        }
      } else {
        const index = this.datesDatasFilterActive.indexOf('Remarques');
        index > -1 ? this.datesDatasFilterActive.splice(index, 1) : null;
      }
    }
  }

  resetBindersAndFolders(): void {
    this.binders = [];
    // Reset checkbox
    this.formSearch.patchValue({
      ClasseurId: null,
      checkBindersIsArchived: null,
    });
    const indexBinder = this.donneesSupplementairesDatasFilterActive.indexOf('ClasseurId');

    indexBinder > -1 ? this.donneesSupplementairesDatasFilterActive.splice(indexBinder, 1) : null;
    this.resetFolders();
  }

  resetFolders(): void {
    this.folders = [];
    this.formSearch.patchValue({
      ChemiseId: null,
      checkFoldersIsArchived: null,
    });
    const indexFolder = this.donneesSupplementairesDatasFilterActive.indexOf('ChemiseId');
    indexFolder > -1 ? this.donneesSupplementairesDatasFilterActive.splice(indexFolder, 1) : null;
  }

  select(): void {
    if (this.treeSelect.value.find((treeValue) => treeValue.key === 'inforiusCheckAllForServices')) {
      this.treeSelect.value = this.servicesParentChild.concat({
        label: '',
        value: 'inforiusCheckAllForServices',
        parentId: null,
        id: null,
        name: '',
        key: 'inforiusCheckAllForServices',
        selectable: true,
        children: [],
      });
      this.setPlaceholderServiceTreeSelect();

      this.patchFormSearchSvcPropIds();
    } else {
      if (this.treeSelect.value.length === this.servicesParentChild.length) {
        this.treeSelect.value = this.treeSelect.value.concat({
          label: '',
          name: '',
          key: 'inforiusCheckAllForServices',
          value: 'inforiusCheckAllForServices',
          selectable: true,
          children: [],
        });
      }
      this.setPlaceholderServiceTreeSelect();
      this.patchFormSearchSvcPropIds();
    }
  }

  public patchFormSearchSvcPropIds(): void {
    this.formSearch.patchValue({
      SvcPropIds:
        this.treeSelect.value.length > 0 ? this.treeSelect.value.filter((x) => x.key !== 'inforiusCheckAllForServices').map((x) => x.value) : null,
    });
    this.changeGeneralDataFilter('SvcPropIds');
  }

  unselect(event, isReinit = false): void {
    if (isReinit) {
      this.accordionGeneralSelected = true;
      setTimeout(() => {
        this.treeSelect.value = [];
        this.setPlaceholderServiceTreeSelect();
        this.formSearch.patchValue({
          SvcPropIds: null,
        });
        this.changeGeneralDataFilter('SvcPropIds');
      }, 500);
    } else {
      if (event.node.key === 'inforiusCheckAllForServices') {
        this.treeSelect.value = [];
        this.setPlaceholderServiceTreeSelect();
        this.formSearch.patchValue({
          SvcPropIds: null,
        });
        this.changeGeneralDataFilter('SvcPropIds');
      } else {
        const indexCheckAll = this.treeSelect.value.map((x) => x.key).indexOf('inforiusCheckAllForServices');
        if (indexCheckAll > -1) {
          this.treeSelect.value.splice(indexCheckAll, 1);
        }
        this.setPlaceholderServiceTreeSelect();
        this.patchFormSearchSvcPropIds();
      }
    }
  }

  setPlaceholderServiceTreeSelect(): void {
    let amountOfSelectedServices = '';
    if (this.treeSelect.value.length === 0) {
      amountOfSelectedServices = this.translationPlaceholderPTree;
    } else if (this.treeSelect.value.length === 1) {
      amountOfSelectedServices = this.treeSelect.value[0].label;
    } else {
      const totalOfSelectedServices = this.treeSelect.value.filter((x) => x.key !== 'inforiusCheckAllForServices').length;
      if (totalOfSelectedServices === this.servicesParentChild.length) {
        amountOfSelectedServices = this.translater.translate('allServicesChecked', {
          value: totalOfSelectedServices,
        });
      } else {
        amountOfSelectedServices = this.translater.translate('xServicesChecked', {
          value: totalOfSelectedServices,
        });
      }
    }
    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
    labelTreeHtml[0].innerHTML = amountOfSelectedServices;
  }

  selectDestServices(event): void {
    if (event.node && event.node.value) {
      if (this.selectedOptionDestService?.value !== event.node.value) {
        this.selectedOptionDestService = _.first(this.servicesParentChild.filter((x) => x.value === event.node.value));
        const labelTreeHtml = document.querySelectorAll('.treeSelectDestServices .p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.selectedOptionDestService.label;
        this.formSearch.patchValue({
          DestinataireServiceIds: event.node.value,
        });
        this.changeDestinataireDataFilter('DestinataireServiceIds');
      } else {
        this.unselectDestService();
      }
    }
  }

  unselectDestService(isReinit = false): void {
    if (isReinit) {
      setTimeout(() => {
        this.selectedOptionDestService = null;
        const labelTreeHtml = document.querySelectorAll('.treeSelectDestServices .p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
        this.treeSelectDestServices.value = [];
        this.formSearch.patchValue({
          DestinataireServiceIds: null,
        });
        this.changeDestinataireDataFilter('DestinataireServiceIds');
      }, 500);
    } else {
      this.selectedOptionDestService = null;
      const labelTreeHtml = document.querySelectorAll('.treeSelectDestServices .p-treeselect-label');
      labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
      this.treeSelectDestServices.value = [];
      this.formSearch.patchValue({
        DestinataireServiceIds: null,
      });
      this.changeDestinataireDataFilter('DestinataireServiceIds');
    }
  }

  searchFull(reset?): void {
    this.mails = [];
    if (!reset) {
      this.hasAdvancedSearch = true;
    }
    this.spinner.show();

    if (this.formSearch.value.DtDocumentMin) {
      this.formSearch.value.DtDocumentMin = moment(this.formSearch.value.DtDocumentMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtDocumentMax) {
      this.formSearch.value.DtDocumentMax = moment(this.formSearch.value.DtDocumentMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtPostaleMin) {
      this.formSearch.value.DtPostaleMin = moment(this.formSearch.value.DtPostaleMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtPostaleMax) {
      this.formSearch.value.DtPostaleMax = moment(this.formSearch.value.DtPostaleMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEntreeMin) {
      this.formSearch.value.DtEntreeMin = moment(this.formSearch.value.DtEntreeMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEntreeMax) {
      this.formSearch.value.DtEntreeMax = moment(this.formSearch.value.DtEntreeMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEcheanceMin) {
      this.formSearch.value.DtEcheanceMin = moment(this.formSearch.value.DtEcheanceMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEcheanceMax) {
      this.formSearch.value.DtEcheanceMax = moment(this.formSearch.value.DtEcheanceMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEncodageMin) {
      this.formSearch.value.DtEncodageMin = moment(this.formSearch.value.DtEncodageMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEncodageMax) {
      this.formSearch.value.DtEncodageMax = moment(this.formSearch.value.DtEncodageMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtCreationMin) {
      this.formSearch.value.DtCreationMin = moment(this.formSearch.value.DtCreationMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtCreationMax) {
      this.formSearch.value.DtCreationMax = moment(this.formSearch.value.DtCreationMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.BoolObjetText) {
      this.formSearch.value.Text = this.formSearch.value.Objet;
    }
    this.formSearch.value.IsAdvancedSearch = true;
    if (this.formSearch.value.NatureIds && this.formSearch.value.NatureIds.length === 1) {
      this.formSearch.value.ExportNatureCustomDatas = true;
    } else {
      this.formSearch.value.ExportNatureCustomDatas = false;
    }
    this.formSearch.value.category = this.formSearch.value.Tag;

    let data = this.cleanObject(this.formSearch.value);
    data = this.setTagOrType(data);

    if (data.Objet) {
      data.Objet = encodeURIComponent(data.Objet);
    }
    sessionStorage.setItem('searchData', JSON.stringify(data));

    let queryParams = Object.keys(data)
      .filter((key) => key !== 'NatureCustomFieldsSearch')
      .map((key) => {
        if (_.isArray(data[key])) {
          return `${key}=${data[key].toString()}`;
        } else {
          return `${key}=${data[key]}`;
        }
      })
      .join('&');

    if (data.NatureCustomFieldsSearch?.length) {
      data.NatureCustomFieldsSearch.forEach((natureCustom) => {
        switch (natureCustom.type) {
          case 'text':
            queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.textValue)}`;
            break;
          case 'date':
            queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.dateValue)}`;
            break;
          case 'checkbox':
            queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.numberValue)}`;
            break;
          case 'decimal':
            queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.decimalValue)}`;
            break;
          case 'integer':
            queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.numberValue)}`;
            break;
          case 'textarea':
            queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.textValue)}`;
            break;
          case 'dropdown':
            queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.listValueItemId)}`;
            break;
        }
      });
    }
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/private/ic/courriers/advancedSearch'], {
        queryParams: {
          advancedSearchData: queryParams,
        },
      })
    );
    window.open(url, '_blank');
    this.spinner.hide();
  }

  cleanObject(object) {
    const propNames = Object.getOwnPropertyNames(object);
    for (let i = 0; i < propNames.length; i++) {
      const propName = propNames[i];
      if (propName === 'NatureCustomFieldsSearch') {
        if (object.NatureCustomFieldsSearch) {
          object.NatureCustomFieldsSearch.map((natureCustom) => {
            if (!natureCustom?.textValue) {
              delete natureCustom.textValue;
            }
            if (!natureCustom?.numberValue) {
              delete natureCustom.numberValue;
            }
            if (!natureCustom?.decimalValue) {
              delete natureCustom.decimalValue;
            }
            if (!natureCustom?.dateValue) {
              delete natureCustom.dateValue;
            }
            if (!natureCustom?.listValueItemId) {
              delete natureCustom?.listValueItemId;
            }
          });
        } else delete object[propName];
      } else {
        if (
          object[propName] === null ||
          object[propName] === undefined ||
          object[propName] === '' ||
          (_.isArray(object[propName]) && object[propName].length === 0)
        ) {
          delete object[propName];
        }
      }
    }

    delete object.recipientsSource; // This is not used as Param for saerch query
    delete object.sendersSource; // This is not used as Param for saerch query

    return object;
  }

  setTagOrType(data): AdvancedSearch {
    if (!data.Tag) {
      sessionStorage.setItem('Tag', 'All'); //au cas ou un user ferait un reload sur la recherche avancée (dans l'onglet ouvert), on DOIT avoir un Tag ou un type :)
      return data;
    } else {
      switch (data.Tag) {
        case 'all':
          data.category = 'All';
          break;
        case 'Entrant':
          delete data.Tag;
          data.Type = 'Entrant';
          break;
        case 'Sortant':
          delete data.Tag;
          data.Type = 'Sortant';
          break;
        case 'Interne':
          delete data.Tag;
          data.Type = 'Interne';
          break;
        case 'AValider':
          ((data.Tag = 'AValider'), (data.Type = 'E'));
          break;
        case 'RecemmentConsultes':
          delete data.Tag;
          data.DtConsultMin = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
          break;
        case 'RecemmentCrees':
          delete data.Tag;
          data.DtEntreeMin = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
          break;
        case 'bacsIds':
          delete data.Tag;
          data.BacIds = localStorage.getItem('bacsIds');
          break;
        default:
          break;
      }
      return data;
    }
  }

  onSelectSenderOrigin(origin: 'iCourrier' | 'iAdmin'): void {
    this.sendersContacts = [];

    this.formSearch.patchValue({
      ExpediteurIds: null,
      ExpediteurIdiAdmins: null,
      sendersSource: origin,
    });
    this.expediteursDatasFilterActive = this.expediteursDatasFilterActive.filter(
      (item) => item !== 'ExpediteurIds' && item !== 'ExpediteurIdiAdmins'
    );
    this.changeSenderSource(origin);
  }

  onSelectRecipientOrigin(origin: 'iCourrier' | 'iAdmin'): void {
    this.formSearch.patchValue({
      DestinataireIds: null,
      DestinataireIdiAdmins: null,
      recipientsSource: origin,
    });
    this.destinatairesDatasFilterActive = this.destinatairesDatasFilterActive.filter(
      (item) => item !== 'DestinataireIds' && item !== 'DestinataireIdiAdmins'
    );
    this.changeRecipientsSource(origin);
  }

  changeSenderSource(origin: 'iCourrier' | 'iAdmin'): void {
    this.fetchSendersContacts(origin);
  }

  changeRecipientsSource(origin: 'iCourrier' | 'iAdmin'): void {
    this.fetchRecipientsContacts(origin);
  }

  fetchSendersContacts(origin: 'iCourrier' | 'iAdmin'): void {
    this.contactsService.fetchContactsSummary(origin).subscribe({
      next: (res: LowInformationContactDto[]) => {
        this.handleSendersContacts(res);
      },
      error: (err: HttpErrorResponse) => {
        console.error(err);
      },
    });
  }

  fetchRecipientsContacts(origin: 'iCourrier' | 'iAdmin'): void {
    this.contactsService.fetchContactsSummary(origin).subscribe({
      next: (res: LowInformationContactDto[]) => {
        this.handleRecipientsContacts(res);
      },
      error: (err: HttpErrorResponse) => {
        console.error(err);
      },
    });
  }

  showUserTooltip(contact): void {
    this.contactsService.fetchContact(contact.value, 'iCourrier').subscribe({
      next: (response) => {
        this.contactInfosComplementary = [];
        this.contactInfosComplementary.push({
          type: response?.typeContactId ? this.contactsTypes.find((contactType) => contactType.id === response.typeContactId)?.typeContact : '/',
          impression_Adresse: response?.adressePrincipale?.impression_Adresse,
          impression_CodePostal: response?.adressePrincipale?.impression_CodePostal,
          impression_Localite: response?.adressePrincipale?.impression_Localite,
          impression_Pays: response?.adressePrincipale?.impression_Pays,
          gsm: response?.adressePrincipale?.gsm,
          telephone: response?.adressePrincipale?.telephone,
          mail: response?.adressePrincipale?.mail,
        });
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error : ', error);
      },
    });
  }

  getOppositeColor(bgColor): string {
    if (bgColor) {
      const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      const r = parseInt(color.substring(0, 2), 16); // hexToR
      const g = parseInt(color.substring(2, 4), 16); // hexToG
      const b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
  }

  openSavedSearch(): void {
    this.openSavedSearchs = true;
    this.meService.getMyPersonalParams('CourrierRechercheSauvegardee').subscribe({
      next: (res) => {
        this.itemsSaved = [];
        if (res?.length > 0) {
          this.itemsSaved = res;
        }
      },
    });
  }

  //Sert à juste patcher la recherche sauvegardée sur le compo
  patchFormSavedSearch(value): void {
    this.spinner.show();

    this.generalDatasFilterActive = [];
    this.expediteursDatasFilterActive = [];
    this.destinatairesDatasFilterActive = [];
    this.donneesComplementairesDatasFilterActive = [];
    this.donneesSupplementairesDatasFilterActive = [];
    this.datesDatasFilterActive = [];

    const data = JSON.parse(value.value);

    this.formSearch.patchValue({
      Confidentiel: data.Confidentiel ? data.Confidentiel : null,
      BoolObjetText: data.BoolObjetText ? data.BoolObjetText : null,
      Tag: data.Tag ? data.Tag : null,
      Objet: data.Objet ? data.Objet : null,
      SvcPropIds: data.SvcPropIds ? data.SvcPropIds : null,
      Type: data.Type ? data.Type : null,
      BoiteArchive: data.BoiteArchive ? data.BoiteArchive : null,
      Id: data.Id ? data.Id : null,

      ExpediteurIds: data.ExpediteurIds ? data.ExpediteurIds : null,
      ExpediteurIdiAdmins: data.ExpediteurIdiAdmins ? data.ExpediteurIdiAdmins : null,
      sendersSource: data.ExpediteurIds ? 'iCourrier' : 'iAdmin',
      ExpediteurLibre: data.ExpediteurLibre ? data.ExpediteurLibre : null,
      RefExpediteur: data.RefExpediteur ? data.RefExpediteur : null,

      CourrierSansServices: data.CourrierSansServices ? data.CourrierSansServices : null,
      CourrierSansDestinataires: data.CourrierSansDestinataires ? data.CourrierSansDestinataires : null,

      DestinataireIds: data.DestinataireIds ? data.DestinataireIds : null,
      DestinataireIdiAdmins: data.DestinataireIdiAdmins ? data.DestinataireIdiAdmins : null,
      recipientsSource: data.DestinataireIds ? 'iCourrier' : 'iAdmin',
      DestinataireLibre: data.DestinataireLibre ? data.DestinataireLibre : null,
      DestinataireServiceIds: data.DestinataireServiceIds ? data.DestinataireServiceIds : null,

      ReferenceRecommande: data.ReferenceRecommande ? data.ReferenceRecommande : null,
      NatureIds: data.NatureIds ? data.NatureIds : null,
      MultipleStIds: data.MultipleStIds ? data.MultipleStIds : null,
      SourceIds: data.SourceIds ? data.SourceIds : null,
      StIds: data.StIds ? data.StIds : null,
      NatureCustomFieldsSearch: data.NatureCustomFieldsSearch ? data.NatureCustomFieldsSearch : null,
      recurrence: data.recurrence ? data.recurrence : null,
      DtEntreeMin: data.DtEntreeMin ? moment(data.DtEntreeMin).toDate() : null,
      DtEntreeMax: data.DtEntreeMax ? moment(data.DtEntreeMax).toDate() : null,
      DtEcheanceMin: data.DtEcheanceMin ? moment(data.DtEcheanceMin).toDate() : null,
      DtEcheanceMax: data.DtEcheanceMax ? moment(data.DtEcheanceMax).toDate() : null,
      DtDocumentMin: data.DtDocumentMin ? moment(data.DtDocumentMin).toDate() : null,
      DtDocumentMax: data.DtDocumentMax ? moment(data.DtDocumentMax).toDate() : null,
      DtPostaleMin: data.DtPostaleMin ? moment(data.DtPostaleMin).toDate() : null,
      DtPostaleMax: data.DtPostaleMax ? moment(data.DtPostaleMax).toDate() : null,
      DtEncodageMin: data.DtEncodageMin ? moment(data.DtEncodageMin).toDate() : null,
      DtEncodageMax: data.DtEncodageMax ? moment(data.DtEncodageMax).toDate() : null,
      Remarques: data.Remarques ? data.Remarques : null,
      Text: data.Text ? data.Text : null,
      Key: data.Key ? data.Key : null,

      EtiquetteIds: data.EtiquetteIds ? data.EtiquetteIds : null,
      TextPhrase: data.TextPhrase ? data.TextPhrase : null,
      typeOfAdvancedSearch: data.typeOfAdvancedSearch ? data.typeOfAdvancedSearch : null,
    });

    this.recipientSourceBoolean = data.DestinataireIds ? true : false; // si on a un destinataireId ca veut dire qu'on a un contact de iCourrier +> obligé de mettre a true; si pas dans tous els cas, on affichera user.
    this.senderSourceBoolean = data.ExpediteurIds ? true : false; // si on a un expediteurId ca veut dire qu'on a un contact de iCourrier +> obligé de mettre a true; si pas dans tous els cas, on affichera user.
    this.changeSenderSource(this.formSearch.value.sendersSource);
    this.changeRecipientsSource(this.formSearch.value.recipientsSource);

    if (data.SvcPropIds) {
      setTimeout(() => {
        this.accordionGeneralSelected = true;
        this.patchServicesNumberOnLoopInTreeSelect(data.SvcPropIds);
      }, 500);

      // Si on a un et un seul service ainsi que un et un seul code de classement alors on peut commencer à patcher les données
      if (data.SvcPropIds?.length === 1 && data.ClassementIds?.length === 1) {
        this.formSearch.patchValue({
          ClassementIds: data.ClassementIds ? data.ClassementIds : null,
        });
        this.changeDonneesSupplementairesDataFilter('ClassementIds');
        this.formSearch.patchValue({
          checkBindersIsArchived: data.ClasseurId ? data.checkBindersIsArchived : false,
        });
        // On va forcément récupérer les fardes afin qu'elles s'affichent dans le visuel. Ce qui veut dire qu'on doit checker si on a un ClasseurId afin de patcher la donnée de la checkbox.
        // En effet, la checkbox va jouer un rôle important dans le getBinders. Cocher la checkbox alors qu'on a AUCUNE farde ne sert à rien.
        this.getBinders(this.formSearch.value.ClassementIds[0]).then(() => {
          // Une fois les fardes récupérées, on doit savoir si on a un ClasseurId a patcher avant de continuer.
          // Pas de classeur veut dire qu'on s'arrête là.
          if (data.ClasseurId) {
            this.formSearch.patchValue({
              ClasseurId: data.ClasseurId,
              checkFoldersIsArchived: data.ChemiseId ? data.checkFoldersIsArchived : false,
            });
            this.changeDonneesSupplementairesDataFilter('ClasseurId');
            if (data.ChemiseId) {
              // Si on a une chemise, alors on fait la récupération de la liste de chemises et on patch la chemise dans le dropdown
              this.getFolders(this.formSearch.value.ClasseurId);
              this.formSearch.patchValue({ ChemiseId: data.ChemiseId });
              this.changeDonneesSupplementairesDataFilter('ChemiseId');
            }
          }
        });
      } else {
        this.resetBindersAndFolders();
      }
    } else this.unselect({ node: { key: 'inforiusCheckAllForServices' } }, true);

    if (data.DestinataireServiceIds) {
      setTimeout(() => {
        this.patchServiceNumberOnLoopInTreeSelect(data.DestinataireServiceIds);
      }, 500);
    } else {
      this.accordionRecipientSelected = true;
      this.unselectDestService(true);
    }

    if (data.recurrence) {
      if (data.DtDocumentMin) {
        const diff = moment(data.DtDocumentMax).diff(moment(data.DtDocumentMin), 'days');
        this.formSearch.patchValue({
          DtDocumentMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtDocumentMin: data.DtDocumentMin ? moment().toDate() : null,
        });
      }
      if (data.DtEcheanceMin) {
        const diff = moment(data.DtEcheanceMax).diff(moment(data.DtEcheanceMin), 'days');
        this.formSearch.patchValue({
          DtEcheanceMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtEcheanceMin: data.DtEcheanceMin ? moment().toDate() : null,
        });
      }
      if (data.DtEntreeMin) {
        const diff = moment(data.DtEntreeMax).diff(moment(data.DtEntreeMin), 'days');
        this.formSearch.patchValue({
          DtEntreeMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtEntreeMin: data.DtEntreeMin ? moment().toDate() : null,
        });
      }
      if (data.DtPostaleMin) {
        const diff = moment(data.DtPostaleMax).diff(moment(data.DtPostaleMin), 'days');
        this.formSearch.patchValue({
          DtPostaleMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtPostaleMin: data.DtPostaleMin ? moment().toDate() : null,
        });
      }
      if (data.DtEncodageMin) {
        const diff = moment(data.DtEncodageMax).diff(moment(data.DtEncodageMin), 'days');
        this.formSearch.patchValue({
          DtEncodageMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtEncodageMin: data.DtEncodageMin ? moment().toDate() : null,
        });
      }
    }

    const cleanForm = this.cleanObject(data);
    const keys = Object.keys(cleanForm);

    //va servir à chopper les filtres actifs
    keys.map((x) => {
      this.changeGeneralDataFilter(x, true);
      this.changeExpediteursDataFilter(x as 'ExpediteurIds' | 'ExpediteurIdiAdmins' | 'ExpediteurLibre' | 'RefExpediteur', true);
      this.changeDestinataireDataFilter(x, true);
      this.changeDonneesSupplementairesDataFilter(x, cleanForm);
      this.changeDataDataFilter(x, true);
    });

    this.setStateOfAccordionByAmountOfFilters();

    this.spinner.hide();
    this.openSavedSearchs = false;
  }

  //Sert à récupérer une recherche enregistrée
  patchFormSearchForModification(value): void {
    this.meService.getMyPersonalParams('CourrierRechercheSauvegardee', value.name).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          this.titleUpdateMode = this.translater.translate('advancedSearch.modificationOfTheSearch', {
            value: value.description,
          });
          this.formSearchSaved.patchValue(res[0]);
          this.updateMode = true;
          this.updateID = res[0].id;
          this.patchFormSavedSearch(value);
        }
      },
    });
  }

  showAllChange(event: boolean): void {
    if (event) {
      this.accordionGeneralSelected = true;
      this.accordionExpediteursSelected = true;
      this.accordionRecipientSelected = true;
      this.accordionSupplementarySelected = true;
      this.accordionComplementarySelected = true;
      this.accordionDatesSelected = true;
    } else {
      this.accordionGeneralSelected = false;
      this.accordionExpediteursSelected = false;
      this.accordionRecipientSelected = false;
      this.accordionSupplementarySelected = false;
      this.accordionComplementarySelected = false;
      this.accordionDatesSelected = false;
    }
  }

  //va update la recherche sauvegardée
  updateSearch(): void {
    if (this.formSearchSaved.valid) {
      this.formSearchSaved.value.name = 'iCourrier' + this.formSearchSaved.value.description.toLowerCase();
      this.cleanTagValue();
      this.formSearch.value.checkBindersIsArchived ? null : (this.formSearch.value.checkBindersIsArchived = false);
      this.formSearch.value.checkFoldersIsArchived ? null : (this.formSearch.value.checkFoldersIsArchived = false);
      this.formSearchSaved.value.value = JSON.stringify(this.formSearch.value);
      this.meService.putMyPersonalParams(this.updateID, 'CourrierRechercheSauvegardee', this.formSearchSaved.value).subscribe({
        next: () => {
          this.formSearchSavedReset();
          this.toastr.success(this.translater.translate('advancedSearch.searchSavedSuccessfully'));
          sessionStorage.setItem('reloadDashboard', '1');
          this.updateMode = false;
        },
      });
    }
  }

  deleteSearch(value): void {
    this.meService.deletePersonalParams(value.id, 'CourrierRechercheSauvegardee').subscribe({
      next: () => {
        this.openSavedSearchs = false;
        this.toastr.success(this.translater.translate('advancedSearch.searchDeletedSuccessfully'));
        sessionStorage.setItem('reloadDashboard', '1');
      },
    });
  }

  saveSearch(): void {
    if (this.formSearchSaved.valid) {
      this.formSearchSaved.value.name = 'iCourrier' + this.formSearchSaved.value.description.toLowerCase();
      this.cleanTagValue();
      this.formSearch.value.checkBindersIsArchived ? null : (this.formSearch.value.checkBindersIsArchived = false);
      this.formSearch.value.checkFoldersIsArchived ? null : (this.formSearch.value.checkFoldersIsArchived = false);
      this.formSearchSaved.value.value = JSON.stringify(this.formSearch.value);

      this.meService.postMyPersonalParams('CourrierRechercheSauvegardee', this.formSearchSaved.value).subscribe({
        next: () => {
          this.savedModal = false;
          this.formSearchSavedReset();
          this.toastr.success(this.translater.translate('advancedSearch.searchSavedSuccessfully'));
          sessionStorage.setItem('reloadDashboard', '1');
        },
      });
    } else {
      this.toastr.error(this.translater.translate('advancedSearch.fillRequiredFields'));
    }
  }

  cleanTagValue(): void {
    if (!this.formSearch.value.Tag) {
      this.formSearch.value.Tag = 'All';
    } else {
      switch (this.formSearch.value.Tag) {
        case 'Entrant':
          this.formSearch.value.Tag = null;
          this.formSearch.value.Type = 'E';
          break;
        case 'Sortant':
          this.formSearch.value.Tag = null;
          this.formSearch.value.Type = 'S';
          break;
        case 'Interne':
          this.formSearch.value.Tag = null;
          this.formSearch.value.Type = 'I';
          break;
        case 'AValider':
          ((this.formSearch.value.Tag = 'AValider'), (this.formSearch.value.Type = 'E'));
          break;
        case 'RecemmentConsultes':
          this.formSearch.value.Tag = null;
          this.formSearch.value.DtConsultMin = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
          break;
        case 'RecemmentCrees':
          this.formSearch.value.Tag = null;
          this.formSearch.value.DtEntreeMin = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
          break;
        case 'bacsIds':
          this.formSearch.value.Tag = null;
          this.formSearch.value.BacIds = localStorage.getItem('bacsIds');
          break;
        default:
          break;
      }
    }
    if (this.formSearch.value.category) this.formSearch.value.category = null;
  }

  formSearchSavedReset(): void {
    this.formSearchSaved.reset();
    this.formSearchSaved.patchValue({
      shared: true,
      hideInDashboard: false,
    });
  }

  checkForComplementaryDatas(natureId, formWithDatas): void {
    if (natureId) {
      this.countOfComplementaryDatasNature = 0;
      this.natureWithComplementaryDatas = this.natureList.find((x) => x.id === natureId[0]);
      this.dataToPrepareForForm = { controls: [] };
      this.hasNatureComplementaryDatas = this.natureWithComplementaryDatas?.natureCustomFields?.length ? true : false;
      if (this.natureWithComplementaryDatas?.natureCustomFields) {
        this.natureWithComplementaryDatas.natureCustomFields.map((field) => {
          if (field.utilisable) {
            //pour savoir si on a des données complémentaires remplies, on va devoir trouver le formWithDatas.NatureCustomFieldsSearch.natureCustomFieldId qui correspond au field.id
            let temp = null;
            if (formWithDatas && formWithDatas.NatureCustomFieldsSearch) {
              const indexOfRightFormWithDatas = formWithDatas.NatureCustomFieldsSearch.map((x) => x.natureCustomFieldId).indexOf(field.id);

              indexOfRightFormWithDatas > -1 ? (temp = formWithDatas.NatureCustomFieldsSearch[indexOfRightFormWithDatas]) : null;
            }
            this.dataToPrepareForForm.controls.push({
              customFieldId: field.id ? field.id : null,
              id: field.customFieldId ? field.customFieldId : field.id,
              name: field.name ? field.name : null,
              description: field.description ? field.description : null,
              label: field.name ? field.name : null,
              textValue: temp && temp?.textValue !== null && temp?.textValue !== '' ? temp.textValue : null,
              dateValue: temp && temp?.dateValue ? temp?.dateValue : null,
              integerValue: temp && temp?.integerValue ? temp?.integerValue : null,
              decimalValue: temp && temp?.decimalValue ? temp?.decimalValue : null,
              numberValue: temp && temp?.numberValue ? temp?.numberValue : null,
              listValueItemId: temp && temp?.listValueItemId ? temp?.listValueItemId : null,
              type: field.customField.type ? field.customField.type.toLowerCase() : null,
              natureId: field.natureId ? field.natureId : null,
              validators: {},
            });
            temp !== null ? (this.countOfComplementaryDatasNature += 1) : null;
          }
        });
        if (this.countOfComplementaryDatasNature) {
          this.accordionComplementarySelected = true;
        }
        // Here we absolutely need to patch all of those values into the form.
        // In fact, the valueChange in <app-complement-data-form doesn't trigger if the user never changes a value.
        // That means, if we simply load a saved advanced search, the valueChanges doesn't trigger and so the form never received those values up here.
        // BUT like we counted this.countOfComplementaryDatasNature the flag displays the amount of datas AND <app-complement-data-form displays the complementary datas
        // So the user is in their rights to think that thoses values WILL be sent into the search... but aren't :(
        // So we call a new method transformDatasForFirstPatchValueComplementaryDatas that morphs the values we have into the ones we receive by the <app-complement-data-form emitter
        this.transformDatasForFirstPatchValueComplementaryDatas(this.dataToPrepareForForm.controls);
      }
    }
  }

  transformDatasForFirstPatchValueComplementaryDatas(complementaryDatas): void {
    const transformedComplementaryDatas = [];
    complementaryDatas.forEach((complementaryData) => {
      transformedComplementaryDatas.push({
        id: complementaryData.id,
        natureCustomFieldId: complementaryData.customFieldId,
        textValue: complementaryData.textValue,
        numberValue: complementaryData.numberValue,
        decimalValue: complementaryData.decimalValue,
        dateValue: complementaryData.dateValue,
        natureId: complementaryData.natureId,
        type: complementaryData.type,
        label: complementaryData.label,
        listValueItemId: complementaryData.listValueItemId,
      });
    });
    this.receive_complementData(transformedComplementaryDatas);
  }

  receive_complementData(data): void {
    this.complementDatasToSend = [];
    data.map((x) => {
      if (
        (x['type'] === 'checkbox' && !!x['numberValue']) ||
        (x['dateValue'] !== null && x['dateValue'] !== '') ||
        (x['decimalValue'] !== null && x['decimalValue'] !== '') ||
        (x['type'] !== 'checkbox' && x['numberValue'] !== null && x['numberValue'] !== '') ||
        (x['textValue'] !== null && x['textValue'] !== '') ||
        (x['type'] === 'dropdown' && x['listValueItemId']?.length > 0)
      ) {
        //Si on a 1 donnée alors on va garder l'objet parce que si on a un objet mais sans donnée => on ne va même pas l'envoyer au back
        // ! pour la checkbox, une valeur a 0 est ni null ni '' et pourtant elle ne doit pas rentrer en compte
        if (x['type'] === 'textarea') {
          x.textareaValue = x.textValue;
        } else if (x['type'] === 'integer') {
          x.IntValueMin = x.numberValue;
          x.IntValueMax = x.numberValue;
        } else if (x['type'] === 'decimal') {
          x.DecimalValueMin = x.decimalValue;
          x.DecimalValueMax = x.decimalValue;
        } else if (x['type'] === 'date') {
          x.DateValueMin = x.dateValue;
          x.DateValueMax = x.dateValue;
        } else if (x['type'] === 'checkbox') {
          x.IsChecked = x.numberValue ? true : false;
        } else if (x['type'] === 'dropdown') {
          x.dropdownValueItemIds = x.listValueItemId;
        }
        this.complementDatasToSend.push(x);
      }
    });
    this.formSearch.patchValue({
      NatureCustomFieldsSearch: this.complementDatasToSend,
    });
    this.countOfComplementaryDatasNature = this.complementDatasToSend.length;
  }

  patchServicesNumberOnLoopInTreeSelect(servicesIds): Promise<boolean> {
    return new Promise((resolve) => {
      const allServicesToBeAdded = [];
      servicesIds.map((serviceId) => {
        //pour chaque serviceId
        this.serviceParent.map((parent) => {
          //si le parentId correspond on push
          if (parent.id === serviceId) {
            allServicesToBeAdded.push(parent);
          } else {
            //Si pas on va devoir entrer dans les enfants
            if (parent.children && parent.children.length > 0) {
              recursive(serviceId, parent.children, allServicesToBeAdded);
            }
          }
        });
      });
      setTimeout(() => {
        this.treeSelect.value = allServicesToBeAdded;
        this.select();
        resolve(true);
      }, 500);

      function recursive(serviceId, children, allServicesToBeAdded) {
        children.map((child) => {
          if (child.id === serviceId) {
            allServicesToBeAdded.push(child);
          } else {
            if (child.children && child.children.length > 0) {
              recursive(serviceId, child.children, allServicesToBeAdded);
            }
          }
        });
      }
    });
  }

  patchServiceNumberOnLoopInTreeSelect(serviceChosen): void {
    const allServicesToBeAdded = [];
    this.serviceParent.map((parent) => {
      //si le parentId correspond on push
      if (parent.id === serviceChosen) {
        allServicesToBeAdded.push(parent);
      } else {
        //Si pas on va devoir entrer dans les enfants
        if (parent.children && parent.children.length > 0) {
          recursive(serviceChosen, parent.children, allServicesToBeAdded);
        }
      }
    });
    setTimeout(() => {
      this.treeSelectDestServices.value = allServicesToBeAdded;
      const labelTreeHtml = document.querySelectorAll('.treeSelectDestServices .p-treeselect-label');
      labelTreeHtml[0].innerHTML = allServicesToBeAdded[0].label;
      this.changeDestinataireDataFilter('DestinataireServiceIds');
    }, 500);

    function recursive(serviceId, children, allServicesToBeAdded) {
      children.map((child) => {
        if (child.id === serviceId) {
          allServicesToBeAdded.push(child);
        } else {
          if (child.children && child.children.length > 0) {
            recursive(serviceId, child.children, allServicesToBeAdded);
          }
        }
      });
    }
  }

  private resetAllDatas(): void {
    this.spinner.show();
    // on reset le formulaire ET on remet les sources à iAdmin
    this.formSearch.reset();
    this.formSearch.patchValue({
      sendersSource: 'iAdmin',
      recipientsSource: 'iAdmin',
    });
    this.recipientSourceBoolean = false;
    this.senderSourceBoolean = false;
    this.changeSenderSource('iAdmin');
    this.changeRecipientsSource('iAdmin');
    //on reset les flags d'affichage de filtres actifs
    this.generalDatasFilterActive = [];
    this.expediteursDatasFilterActive = [];
    this.destinatairesDatasFilterActive = [];
    this.donneesComplementairesDatasFilterActive = [];
    this.donneesSupplementairesDatasFilterActive = [];
    this.datesDatasFilterActive = [];
    // On reset les accordéons qui ne seront pas affectés par le reset unselect
    // On unselect les services et les services destinataires
    this.unselect({ node: { key: 'inforiusCheckAllForServices' } }, true);
    this.unselectDestService(true);
    setTimeout(() => {
      this.showAllChange(false);
      this.spinner.hide();
    }, 1000);
  }

  public onChangeToggleButtonUsersContacts(
    typeOfSource: 'recipientsSource' | 'sendersSource',
    event: { originalEvent: PointerEvent; checked: boolean }
  ): void {
    let origin: 'iCourrier' | 'iAdmin';
    event.checked ? (origin = 'iCourrier') : (origin = 'iAdmin');
    typeOfSource === 'recipientsSource' ? this.onSelectRecipientOrigin(origin) : this.onSelectSenderOrigin(origin);
  }

  public changeAccordionSelectionState(
    event: boolean,
    accordionName:
      | 'accordionGeneralSelected'
      | 'accordionExpediteursSelected'
      | 'accordionRecipientSelected'
      | 'accordionSupplementarySelected'
      | 'accordionComplementarySelected'
      | 'accordionDatesSelected'
  ): void {
    this[accordionName] = event;
  }

  private setStateOfAccordionByAmountOfFilters(): void {
    this.accordionGeneralSelected = this.generalDatasFilterActive.length ? true : false;
    this.accordionExpediteursSelected = this.expediteursDatasFilterActive.length ? true : false;
    this.accordionRecipientSelected = this.destinatairesDatasFilterActive.length ? true : false;
    this.accordionSupplementarySelected = this.donneesSupplementairesDatasFilterActive.length ? true : false;
    this.accordionComplementarySelected = this.countOfComplementaryDatasNature ? true : false;
    this.accordionDatesSelected = this.datesDatasFilterActive.length ? true : false;
  }
}
